<template>
    <div class="contentBox">
        <div class="header-center">
            <a-row style="height: 100%;">
                <a-col :span="12" style="text-align: left;height: 100%;display: flex;align-items: center;">
									<img src="../assets/image/logo.png" style="width: 96px;height: 18px;display: inline-block;margin-right: 12px;" />
									<span class="logo_title">工控漏洞子库</span>
                    <!-- <img src="../assets/image/logo/header_logo.png" alt="" style="width: 248px;height: 21px;margin-top: 30px;"> -->
                </a-col>
                <a-col :span="12" style="text-align: right;height: 100%;">
                    <a-menu  mode="horizontal" style="margin-top: 4px;"  :defaultSelectedKeys="[this.$route.meta.selectKey]" :selectedKeys="[this.$route.meta.selectKey]">
                        <a-menu-item key="index">
                            <router-link to="/index">首页</router-link>
                        </a-menu-item>
                        <a-menu-item key="bugList">
                            <router-link to="/bugList">漏洞列表</router-link>
                        </a-menu-item>
<!--                        <a-menu-item key="hotMsg">-->
<!--                            <router-link to="/hotMsg">-->
<!--                                热点事件-->
<!--                            </router-link>-->
<!--                        </a-menu-item>-->
												<!-- <a-menu-item key="present">
														<router-link to="/present">
																报告发布
														</router-link>
												</a-menu-item> -->
<!--                        <a-menu-item key="notice">-->
<!--                            <router-link to="/notice">-->
<!--                                安全公告-->
<!--                            </router-link>-->
<!--                        </a-menu-item>-->
                        <a-menu-item key="bugEcharts">
                            <router-link to="/bugEcharts">漏洞统计</router-link>
                        </a-menu-item>
                    </a-menu>
                </a-col>
            </a-row>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            };
        },
        created() {
            console.log(this.$route.meta.selectKey)
        }
    };
</script>

<style scoped>
    .contentBox{
        width: 100%;
				height: 70px;
        /* margin-bottom: 20px; */
    }
    .header-center{
        width: 1200px;
				height: 70px;
        margin: 0 auto;
    }
		.logo_title{
			display: inline-block;
			/* height: 70px;
			line-height: 70px; */
			font-size: 18px;
			color: #333333;
			font-family: "PingFangSC-Semibold";
			font-weight: bold;
		}
    /deep/ .ant-menu-horizontal{
        border: none;
    }
    /deep/ .ant-menu-item{
        font-size: 14px;
        font-weight: 400;
        color: #333;
        text-align: center;
        line-height: 14px;
        padding: 25px 2px;
        margin: 0 10px;
    }
    /deep/ .ant-menu-item:hover{
        color: #2978c3;
    }

</style>
